import { call, put, takeLatest } from 'redux-saga/effects';

import { receiveAPIResponse, requestAPIFailed } from 'src/redux/api/actions';
import { apiCallAsync } from 'src/redux/api/saga';
import {
  ACR_INFO_BOX_ACTION,
  UPDATE_REVIEW_STATE_DATA_ACTION,
  UPDATE_REVIEW_STATE_DATA_KEY,
} from 'src/redux/constants';
import type { ViewAction } from 'src/redux/viewState/types';
import { getActionAPISource } from 'src/utils';
import { receivePostAcrInfoBoxSuccess } from './actions';

export function* postSagaBase(action: ViewAction) {
  try {
    const urlObjId = action.value.url_format._id_;
    let url = getActionAPISource(action.dataKey);
    url = url.replace(new RegExp('_id_', 'g'), urlObjId);

    const response = yield call(apiCallAsync, url, action.value.data, 'post');

    if (response.status >= 200 && response.status < 300) {
      yield put(receiveAPIResponse(action.dataKey, response.data));
    } else {
      console.warn(`API call ${action.dataKey} has failed.`);
    }
  } catch (e) {
    yield put(requestAPIFailed(action.dataKey, e.toString()));
    console.error(e);
  }
}

export function* postAcrInfoBoxSaga(action: ViewAction) {
  try {
    const urlObjId = action.value.url_format._id_;
    let url = getActionAPISource(action.dataKey);
    url = url.replace(new RegExp('_id_', 'g'), urlObjId);

    const response = yield call(apiCallAsync, url, action.value.data, 'post');

    if (response.status >= 200 && response.status < 300) {
      yield put(receivePostAcrInfoBoxSuccess(action.value.data));
    } else {
      console.warn(`API call ${action.dataKey} has failed.`);
    }
  } catch (e) {
    yield put(requestAPIFailed(action.dataKey, e.toString()));
    console.error(e);
  }
}

export function* watchRequestDataInfoBoxSaga() {
  yield takeLatest(ACR_INFO_BOX_ACTION, postAcrInfoBoxSaga);
}

export function* updateReviewStateSaga(action: ViewAction) {
  try {
    let url = getActionAPISource(UPDATE_REVIEW_STATE_DATA_KEY);
    url = url.replace(new RegExp('_id_', 'g'), action.value.reportPk);
    const response = yield call(apiCallAsync, url, action.value, 'put');
    if (response.status === 200) {
      yield put(receiveAPIResponse(action.dataKey, response.data));
    } else {
      throw new Error('API call has failed');
    }
  } catch (e) {
    yield put(requestAPIFailed(action.dataKey, e.toString()));
    console.error(e);
  }
}

export function* watchUpdateReviewStateSaga() {
  yield takeLatest(UPDATE_REVIEW_STATE_DATA_ACTION, updateReviewStateSaga);
}
